import {Style, Stroke, Circle, Fill} from 'ol/style';

const routeColors = {
    'Bruchberg': '#d20bc8',
    'Engelsburger': '#f2443c',
    'Jordanshöhe': '#f2443c',
    'Kobold': '#d20bc8',
    'Mariechenweg': '#f2443c',
    'Oderberge': '#d20bc8',
    'Odertal': '#d20bc8',
    'Odertal-nobar': '#d20bc8',
    'Panorama': '#1518b6',
    'Panorama-Sperrental': '#f2443c',
    'Schlufter': '#1518b6',
    'Sieberberg': '#f2443c',
    'Siebertal': '#d20bc8',
    'Siebertal-nobar': '#d20bc8',
    'Silberteich': '#d20bc8',
    'Sonnenberge': '#d20bc8',
    'Sperrental-Kuppe': '#f2443c',
    'Waage': '#1518b6'
};

function getJunctionStyle(type) {
    let fillColor, strokeColor, radius;
    if (typeof type == 'undefined') {
        fillColor = 'rgba(0,255,0,0.1)';
        strokeColor = 'red';
        radius = 16;
    } else {
        fillColor = 'rgba(255,240,0,0.6)';
        strokeColor = 'yellow';
        radius = 12;
    }
    const style = new Style({
        image: new Circle({
            radius: radius,
            fill: new Fill({
                color: fillColor
            }),
            stroke: new Stroke({
                color: strokeColor,
                width: 5
            })
        })
    });
    return style;
}
function getWanderabschnittStyle(type) {
    let fillColor, strokeColor;
    if (typeof type == 'undefined') {
        strokeColor = 'rgb(250,66,41)';
    } else {
        strokeColor = 'rgb(96,25,156)';
    }
    return new Style({
        stroke: new Stroke({
            color: strokeColor,
            width: 4
        })
    });
}
function getVectorStyle(name, feature) {
    const type = feature.getGeometry().getType();
    if (type == 'LineString') {
        let strokeColor = routeColors[name];
        let width = 3;
        if (typeof strokeColor === 'undefined') {
            if (name === 'wege') {
                strokeColor = 'black';
                width = 1;
            } else if (name === 'pfade') {
                strokeColor = 'green';
                width = 1;
            }
        }
        return new Style({
            stroke: new Stroke({
                color: strokeColor,
                width: width
            }),
        });
    }

    return undefined;
}

const Styles = {};
Styles.getJunctionStyle = getJunctionStyle;
Styles.getWanderabschnittStyle = getWanderabschnittStyle;
Styles.getVectorStyle = getVectorStyle;
export default Styles;
